import {
  Space,
  Image as AntImage
} from "antd";
import styled from "styled-components";
import { WarningFilled, QuestionFilled, IMG_QR } from "@assets";

export const MainContainer = styled.div`
position: relative;
height: 100vh;
`;
export const RootContainer = styled.div`
  padding: 16px;
  position: relative;
  z-index: ${props => props.open !== 'true' ? 10 : 0};
  display: flex;
  flex-direction: column;

  .ant-collapse {
    background-color: #fff;
    border: 1px solid #e1cce0;

    .ant-image {
      margin-bottom: 12px;
    }
  }

  .ant-collapse-header {
    flex-direction: row-reverse;
  }

  .ant-collapse-header-text {
    font-size: 14px;
    font-weight: bold;
  }

  @media screen and (max-width: 320px) {
    padding: 16px 8px;
  }
`;

export const TopContainer = styled.div`
border-radius: 12px;
background: linear-gradient(180deg, #9027E1 0%, #58297B 104.12%);
`;

export const AmountWrapper = styled.div`
padding: 8px 16px;
display: flex;
gap: 8px;
align-items: center;
justify-content: flex-start;

@media screen and (max-width: 335px) {
  padding: 8px;
  }
`;

export const AmountText = styled.div`
font-size: 14px;
font-style: normal;
font-weight: 500;
line-height: 1.5;
color: #fff;

  @media screen and (max-width: 325px) {
    font-size: 13px;
  }
`;

export const Text = styled.div`
  color: #5D5189;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 150% */
`;

export const QRCodeContainer = styled.div`
  margin-inline: 16px;
  display: flex;
  align-items: center;
  justify-content: left;
  gap: 24px;
  padding: 12px 0;
  border-top: 1px solid #2D2A2A;

  @media screen and (max-width: 450px) {
    gap: 0px;
    justify-content: space-between;
  }
`;

export const QRCodeText = styled.div`
padding: 0px 12px;
margin-top:4px;
background-color: #fff;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  color: #49028E;
  cursor: pointer;
  border-radius: 8px;

  @media screen and (max-width: 400px) {
    padding: 0px 8px;
    font-size: 10px;
  }
`;

export const QRCodeImage = styled(AntImage).attrs({
  alt: "QR",
  src: IMG_QR,
  preview: false,
})`
  padding: 11px;
  border-radius: 12px;
  background-color: #9027E1;

  @media screen and (max-width: 352px) {
    max-width: 70px;
  }

  @media screen and (max-width: 335px) {
    max-width: 50px;
  }
`;

export const Wrapper = styled.div`
  min-width: 60px;
  display: flex;
  justify-content: center;
  width: 100%;
`;

export const InfoWrapper = styled.div`
display: flex;
flex-direction: column;
gap: 4px;
`;

export const InfoLabel = styled.div`
font-size: 12px;
font-style: normal;
font-weight: 500;
line-height: 1.5;
color: #949393;
`;

export const InfoText = styled.div`
font-size: 16px;
font-style: normal;
font-weight: 400;
line-height: 1.5;
color: #fff;

@media screen and (max-width: 375px) {
  font-size: 14px;
}

@media screen and (max-width: 350px) {
  font-size: 13px;
}
`;

export const Box = styled.div`
padding: 16px;
display: flex;
flex-direction: column;
gap: 12px;
border-radius: 12px;
background: #49028E;

  @media screen and (max-width: 335px) {
    padding: 16px 8px;
  }
`;

export const ImageBox = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
  justify-content: flex-start;

  @media screen and (max-width: 352px) {
gap: 6px;
}
`;

export const LightText = styled.div`
font-size: 14px;
font-style: normal;
font-weight: 400;
line-height: normal;
color: #fff;
`;

export const LightTextLg = styled(LightText)`
font-size: 12px;
`;

export const Image = styled.img.attrs({
  alt: "img",
})`
  width: 78px;
  border-radius: 12px;

  @media screen and (max-width: 390px) {
    width: 68px;
  }

  @media screen and (max-width: 360px) {
    width: 60px;
  }

  @media screen and (max-width: 335px) {
    width: 50px;
  }
`;

export const TextWrapper = styled.div`
`;

export const CopyText = styled.div`
padding: 0px 12px;
border-radius: 8px;
background-color: #fff;

font-size: 12px;
font-weight: 500;
color: #49028E;
line-height: 1.5;
cursor: pointer;
`;

export const AccountInfo = styled(Space)`
display: flex;
gap: 4px;
align-items: center;
justify-content: flex-start;

.ant-space-item:nth-child(2) {
  flex: 1;
}

.ant-space-item:last-child {
  align-self: flex-end;
}
`;

export const QuestionIcon = styled(QuestionFilled)`
cursor: pointer;
`;

export const DigitBox = styled.div`
  margin-top: 24px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  grid-gap: 12px;
  text-align: center;

  .ant-space {
    gap: 4px !important;
  }
`;

export const ButtonWrapper = styled.div`
  width: 100%;
  text-align: center;
  position: relative;
  margin-bottom: 24px;

  .ant-btn {
    height: 55px;
    span {
      color: #fff;
      font-weight: 500;
    }
  }

  .ant-btn:disabled {
    background: lightgray !important;
    color: gray !important;

    :hover {
    color: gray !important;
    }
  }
`;

export const SpinWrapper = styled.div`
  height: calc(100vh - 70px);
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const StyledInput = styled.input`
  width: 20px !important;
  height: 30px !important;
  border-radius: 4px !important;
  text-align: center !important;
  border: 1px solid ${(props) => (props.status === "error" ? "red" : "transparent")} !important;
  font-size: 17px !important;
  background-color: #F8EEFF !important;
  color: #000 !important;
  -moz-appearance: textfield;
  appearance: textfield;

  ::-webkit-inner-spin-button,
  ::-webkit-outer-spin-button {
    -webkit-appearance: none; /* WebKit */
    margin: 0;
  }
  ::-webkit-inner-spin-button:disabled,
  ::-webkit-outer-spin-button:disabled {
    display: none;
  }
`;

export const SlideImage = styled.img.attrs({
  alt: "slide-img",
})`
  width: 100%;
  height: auto;
  object-fit: cover;
  cursor: pointer;
`;

export const EmptyBox = styled.div`
height: calc(100vh - 70px);
display: flex;
flex-direction: column;
align-items: center;
justify-content: center;
gap: 16px;
width: 100%;

.ant-btn-primary {
  height: 52px;

  span {
    color: #fff;
    font-size: 16px;
    font-weight: 500;
  }
}
`;

export const EmptyText = styled.div`
padding: 0 15%;
font-size: 14px;
font-weight: 500;
text-align: center;
color: #49028E;

@media screen and (max-width: 360px) {
  padding: 0 12%;
}
`;

export const WarningImage = styled(WarningFilled)`
width: 50px;
height: 50px;
`;

export const SampleBox = styled.div`
cursor: pointer;
align-self: center;
display: inline-flex;
padding: 6px 12px;
justify-content: center;
align-items: center;
gap: 4px;
border-radius: 8px;
background-color: #E5E0F5;

div {
  font-size: 14px;
  font-weight: 500;
  line-height: 1.5;
  color: #49028E;
}
`;

export const ScreenShotBox = styled.div`
  margin: 24px 0 0;
`

export const PalePurpleWrapper = styled.div`
  margin: 12px 0 24px;
  padding: 16px;
  border-radius: 5px;
  border: 1px solid #9027E1;
  background: #F8EEFF !important;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 4px;

  svg{
    width: 24px;
    height: 24px;
  }

  @media screen and (max-width: 400px) {
    padding: 12px;
  }
`

export const UploadText = styled.p`
  color: #49028E;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 150% */
`

export const RowFlex = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
`

export const ColFlex = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;

`

export const BlackText = styled.p`
  color: var(--All-black, #000);
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 150% */
  text-align: left;

  @media screen and (max-width: 400px) {
    font-size: 14px;
  }
`

export const GrayText = styled.p`
  color: var(--Second-Text, #9B92BB);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 171.429% */
  text-align: left;
`

export const ChangeBtn = styled.div`
  background: var(--Primary-2, linear-gradient(180deg, #9027E1 0%, #58297B 104.12%));
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin-bottom: 26px;
  width: 60px;
  font-size: 14px;
`

export const SSWarningText = styled.div`
  color: #23AB41;
  text-align: center;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
`